import {
  type CampaignTypeName,
  isKnownCampaignType,
  type KnownCampaignTypeName,
} from "@decibeltrade/sdk";

import type { RewardCategory, RewardsFilter, RewardStatus } from "./types";

export type CampaignVisibility = "public" | "recipient_only" | "hidden";

interface CampaignTypeTraits {
  category: RewardCategory;
  visibility: CampaignVisibility;
}

export const CATEGORY_TRANSLATION_KEYS = {
  fee_rebate: "feeRebate",
  maker_rebate: "makerRebate",
  liquidation_credit: "liquidationCredit",
  volume_milestone: "volumeMilestone",
  first_funded_trial: "firstFundedTrial",
  affiliate: "affiliate",
  other: "other",
} as const satisfies Record<RewardCategory, string>;

export const STATUS_TRANSLATION_KEYS = {
  claimable: "claimable",
  in_progress: "inProgress",
  not_eligible: "notEligible",
  claimed: "claimed",
  expired: "expired",
} as const satisfies Record<RewardStatus, string>;

export const FILTER_TRANSLATION_KEYS = {
  all: "all",
  ...STATUS_TRANSLATION_KEYS,
} as const satisfies Record<RewardsFilter, string>;

export const CAMPAIGN_TYPE_TRAITS = {
  fee_rebate: { category: "fee_rebate", visibility: "public" },
  maker_incentive: { category: "maker_rebate", visibility: "public" },
  liquidation_rebate: { category: "liquidation_credit", visibility: "public" },
  volume_milestone: { category: "volume_milestone", visibility: "public" },
  first_funded_trial: { category: "first_funded_trial", visibility: "hidden" },
  affiliate: { category: "affiliate", visibility: "recipient_only" },
  discretionary: { category: "other", visibility: "recipient_only" },
} as const satisfies Record<KnownCampaignTypeName, CampaignTypeTraits>;

const UNKNOWN_CAMPAIGN_TYPE_TRAITS: CampaignTypeTraits = {
  category: "other",
  visibility: "hidden",
};

export function campaignTypeTraits(type: CampaignTypeName): CampaignTypeTraits {
  return isKnownCampaignType(type) ? CAMPAIGN_TYPE_TRAITS[type] : UNKNOWN_CAMPAIGN_TYPE_TRAITS;
}
